import { NormalizedNumber } from '@sparkdotfi/common-universal'

import { SparkLendBanner } from '../components/sparklend-banner/SparkLendBanner'
import { SPARK_VAULTS_V2_ENABLED } from '@/config/chain/flags'
import { ConnectWalletPanel } from '@/features/points/components/connect-wallet-panel/ConnectWalletPanel'
import { EarnPointsBanner } from '@/features/points/components/earn-points-banner/EarnPointsBanner'
import {
  PointsEarningsPanel,
  PointsEarningsPanelProps,
} from '@/features/points/components/points-earnings-panel/PointsEarningsPanel'
import { PointsHeader } from '@/features/points/components/points-header/PointsHeader'
import { PageLayout } from '@/ui/layouts/PageLayout'

export interface GuestViewProps {
  pointsSeason: number
  previousPointsSeason: number
  userChainId: number
  openConnectWalletModal: () => void
  showSparkLendBanner: boolean
}

export function GuestView({
  pointsSeason,
  previousPointsSeason,
  userChainId,
  openConnectWalletModal,
  showSparkLendBanner,
}: GuestViewProps) {
  const pointsEarnings: PointsEarningsPanelProps['pointsEarnings'] = [
    ...[
      { type: 'staking' as const },
      { type: 'referral' as const },
      { type: 'loyalty' as const },
      { type: 'governance' as const },
      { type: 'hold-susds' as const },
      ...(SPARK_VAULTS_V2_ENABLED
        ? ([{ type: 'hold-spusdc' }, { type: 'hold-spusdt' }, { type: 'hold-speth' }] as const)
        : []),
    ].map((p) => ({ ...p, amount: NormalizedNumber.ZERO, campaignActive: true })),
    { type: 'hold-susdc' as const, amount: NormalizedNumber.ZERO, campaignActive: false },
  ]

  return (
    <PageLayout>
      <PointsHeader pointsSeason={pointsSeason} />
      <div className="grid grid-cols-1 gap-5 lg:grid-cols-[11fr_5fr]">
        <div className="grid grid-cols-1 gap-5">
          {showSparkLendBanner && <SparkLendBanner />}
          <PointsEarningsPanel
            userChainId={userChainId}
            invitedUsers={0}
            pointsEarnings={pointsEarnings}
            previousPointsSeason={previousPointsSeason}
            onInvite={() => {}}
            onBuy={() => {}}
            isGuestMode
          />
          <ConnectWalletPanel openConnectWalletModal={openConnectWalletModal} />
        </div>
        <EarnPointsBanner pointsSeason={pointsSeason} />
      </div>
    </PageLayout>
  )
}
